export type SortKey = 'newest' | 'quantity_desc' | 'quantity_asc' | 'price_asc' | 'price_desc';

interface SortToggleProps {
  sort: SortKey;
  onSortChange: (v: SortKey) => void;
}

// Field-based sort: 最新发布 / 数量(↑↓) / 价格(↑↓).
// Clicking an active field flips its direction; default first click = desc (从高到低).
const FIELDS: { key: 'newest' | 'quantity' | 'price'; label: string }[] = [
  { key: 'newest', label: '最新发布' },
  { key: 'quantity', label: '数量' },
  { key: 'price', label: '价格' },
];

function fieldOf(sort: SortKey): 'newest' | 'quantity' | 'price' {
  if (sort.startsWith('quantity')) return 'quantity';
  if (sort.startsWith('price')) return 'price';
  return 'newest';
}

function dirOf(sort: SortKey): 'asc' | 'desc' | null {
  if (sort.endsWith('_asc')) return 'asc';
  if (sort.endsWith('_desc')) return 'desc';
  return null;
}

export default function SortToggle({ sort, onSortChange }: SortToggleProps) {
  const activeField = fieldOf(sort);
  const dir = dirOf(sort);

  const handleClick = (key: 'newest' | 'quantity' | 'price') => {
    if (key === 'newest') {
      onSortChange('newest');
      return;
    }
    // flip when already active, else default to desc
    const nextDir = activeField === key && dir === 'desc' ? 'asc' : 'desc';
    onSortChange(`${key}_${nextDir}` as SortKey);
  };

  return (
    <div className="flex items-center gap-1 bg-background-100 rounded-full px-1 py-1 self-start sm:self-auto">
      {FIELDS.map((f) => {
        const active = activeField === f.key;
        return (
          <button
            key={f.key}
            onClick={() => handleClick(f.key)}
            className={`flex items-center gap-1 px-4 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
              active
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-500 hover:text-foreground-700'
            }`}
          >
            {f.label}
            {f.key !== 'newest' && active && dir && (
              <i className={dir === 'desc' ? 'ri-arrow-down-line' : 'ri-arrow-up-line'}></i>
            )}
          </button>
        );
      })}
    </div>
  );
}
